<template>
  <v-card>
    <v-card-title class="headline font-medium black--text">
      <template v-if="$store.getters.languageGetter === '1'">
        عنوان الشركة
      </template>
      <template v-else>
        Address
      </template>
      <v-btn
        icon
        class="ms-auto"
        @click="resetComponent();$emit('update:close')"
      >
        <v-icon size="24">
          mdi-close
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-divider />
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      class="pa-2"
    >
      <v-container>
        <v-row>
          <v-col
            class="py-0"
            cols="6"
          >
            <v-text-field
              v-model="name"
              :rules="nameRules"
              :label="$store.getters.languageGetter === '1' ? 'الاسم' : 'Name'"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            class="py-0"
          />
          <v-col
            class="py-0"
            cols="6"
          >
            <v-select
              v-model="country"
              :items="webConfig.countryList"
              :rules="countryRules"
              :label="$store.getters.languageGetter === '1' ? 'اختر البلد' : 'Country'"
              :item-text="getCountryNameConcat"
              item-value="id"
              outlined
              dense
              no-data-text="Nothing here"
              required
            />
          </v-col>
          <!-- <v-col
            class="py-0"
            cols="6"
          >
            <v-text-field
              v-model="province"
              :rules="provinceRules"
              label="State/Province/Region"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col
            class="py-0"
            cols="6"
          >
            <v-text-field
              v-model="city"
              :rules="cityRules"
              label="City"
              outlined
              dense
              clearable
            />
          </v-col> -->
          <v-col
            class="py-0"
            cols="6"
          >
            <v-text-field
              v-model="zipCode"
              :rules="zipCodeRules"
              :label="$store.getters.languageGetter === '1' ? 'الرمز البريدي' : 'Zip Code'"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col
            class="py-0"
            cols="12"
          >
            <v-text-field
              v-model="address"
              :rules="addressRules"
              :label="$store.getters.languageGetter === '1' ? 'عنوان الشركة' : 'Address'"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col
            class="py-0"
            cols="12"
          >
            <v-text-field
              v-model="phone"
              :rules="phoneRules"
              :label="$store.getters.languageGetter === '1' ? 'هاتف' : 'Phone'"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col
            class="py-0"
            cols="12"
          >
            <v-checkbox
              v-model="isDefault"
              class="my-0"
              :label="$store.getters.languageGetter === '1' ? 'تعيين الافتراضي' : 'Set to default'"
            />
          </v-col>
          <v-col
            class="py-0"
            cols="12"
          >
            <v-btn
              :disabled="!valid"
              :loading="submitting"
              :dark="valid"
              color="#f51414"
              depressed
              class="mb-2 me-2"
              @click="addOrSaveAddress"
            >
              <template v-if="$store.getters.languageGetter === '1'">
                يحفظ
              </template>
              <template v-else>
                Save
              </template>
            </v-btn>
            <v-btn
              depressed
              class="mb-2"
              outlined
              @click="resetComponent();$emit('update:close')"
            >
              <template v-if="$store.getters.languageGetter === '1'">
                يلغي
              </template>
              <template v-else>
                Cancel
              </template>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Address',
  props: {
    id: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      valid: true,
      nameRules: [(v) => !!v || 'Please enter your first name'],
      provinceRules: [(v) => !!v || 'Please enter your State/Province/Region'],
      cityRules: [(v) => !!v || 'Please enter your City'],
      phoneRules: [(v) => !!v || 'Please enter your Phone Number'],
      countryRules: [(v) => !!v || 'Please select your country'],
      zipCodeRules: [(v) => !!v || 'Please enter your Zip Code'],
      addressRules: [(v) => !!v || 'Please enter your Address'],
      name: '',
      country: '',
      address: '',
      city: '',
      province: '',
      phone: '',
      zipCode: '',
      isDefault: false,
      submitting: false,
    };
  },
  computed: {
    ...mapState(['user', 'webConfig']),
    params() {
      return {
        contacter: this.name,
        mobile: this.phone,
        addressId: this.country,
        buyerId: this.user.sellerId,
        buyerUid: this.user.id,
        isDefault: this.isDefault ? '1' : '0',
        zipCode: this.zipCode,
        countryId: this.country,
        addressPart: `${this.province}/${this.city}/${this.address}`,
      };
    },
  },
  watch: {
    id(newValue) {
      if (newValue) {
        this.name = this.item.contacter;
        this.country = this.item.addressId;
        this.phone = this.item.mobile;
        this.isDefault = this.item.isDefault === '1';
        this.zipCode = this.item.zipCode;
        this.province = this.item.province;
        this.city = this.item.city;
        this.address = this.item.address;
      }
    },
  },
  created() {
    if (this.id) {
      this.name = this.item.contacter;
      this.country = this.item.addressId;
      this.phone = this.item.mobile;
      this.isDefault = this.item.isDefault === '1';
      this.zipCode = this.item.zipCode;
      this.province = this.item.province;
      this.city = this.item.city;
      this.address = this.item.address;
    }
  },
  methods: {
    ...mapActions('center', ['addAddressAsync', 'editAddressAsync']),
    getCountryNameConcat(item) {
      return `${item.dnames}(${item.dnamesEn})`;
    },
    resetComponent() {
      this.name = '';
      this.country = '840';
      this.phone = '';
      this.isDefault = false;
      this.zipCode = '';
      this.province = '';
      this.city = '';
      this.address = '';
      this.$refs.form.reset();
    },
    addOrSaveAddress() {
      if (this.$refs.form.validate()) {
        this.submitting = true;
        const params = { ...this.params };
        if (this.id) {
          params.id = this.id;
          this.editAddressAsync(params).then(() => {
            this.resetComponent();
            this.$emit('update:added');
            this.$emit('update:close');
          }).finally(() => {
            this.submitting = false;
          });
        } else {
          this.addAddressAsync(params).then(() => {
            this.resetComponent();
            this.$emit('update:close');
          }).finally(() => {
            this.submitting = false;
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
